import { Button } from '@mui/material';
import { Add, CheckCircle, Slideshow } from '@mui/icons-material';
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch } from 'react-redux';
import { handleGetAllSlides } from "store/slides/thunk";
import styled from "styled-components";
import PresentationSlides from "./presentationSlides";
import { useGetAllSlidesData } from "store/slides/selectors";
import BadgeButton from "components/AdminBooks/BadgeButton";
import { message } from "antd";
import SentryWrap from 'components/Sentry';

const AdminSlidesComponent = ({ bookId, pageId, book, hasPermission = true }) => {
  const [openModal, setOpenModal] = useState(false);
  const dispatch = useDispatch();
  const allSlideData = useGetAllSlidesData();
  const [windowLayout, setWindowLayout] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowLayout({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const onClose = async () => {
    dispatch(handleGetAllSlides(bookId));
    setOpenModal(false);
  };

  const checkSlide = useMemo(() => allSlideData?.find((obj) => obj?.book_id === String(bookId) && obj?.page_id === String(pageId)), [bookId, pageId,allSlideData]);

  return (
    <SentryWrap>
      <BadgeButton
        onClick={() => {
          if (!hasPermission) {
            message.warning('You do not have permission to access this feature.');
            return;
          }
          dispatch(handleGetAllSlides(bookId))
          setOpenModal(true);
        }}
        startIcon={<Slideshow />}
        showBadge={checkSlide?.pages?.length > 0}
        backgroundColor="#0ea5e9"
      >
        Slides
      </BadgeButton>
      {openModal && (
        <FixedLayoutContaner
          className="custom-modal customModalSlidesComp"
          style={{ width: windowLayout?.width, height: windowLayout?.height }}
        >
          <PresentationSlides pageId={pageId} bookId={bookId} book={book} setOpenModal={setOpenModal} />
        </FixedLayoutContaner>
      )}
    </SentryWrap>
  );
};

export default AdminSlidesComponent;

const FixedLayoutContaner = styled.div`
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  background-color: #f8f9fa;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  z-index: 999;
  overflow: auto;
`;
